// extracted by mini-css-extract-plugin
export var NavContainer = "landing-module--NavContainer--1PxH0";
export var centerText = "landing-module--centerText--7RjSN";
export var contentCenter = "landing-module--contentCenter--79TMA";
export var contentContainer = "landing-module--contentContainer--NuIX1";
export var contentLeft = "landing-module--contentLeft--Hgdey";
export var contentLeftContainer = "landing-module--contentLeftContainer--OZIZ8";
export var contentRight = "landing-module--contentRight--ShCHJ";
export var contentRightContainer = "landing-module--contentRightContainer--JrdWq";
export var contentText = "landing-module--contentText--GcrNz";
export var data = "landing-module--data--nj-YH";
export var hideData = "landing-module--hideData--+IFWt";
export var mainContainer = "landing-module--mainContainer--zXAY-";
export var reverseRightIcon = "landing-module--reverseRightIcon--ym+wZ";
export var rightBar = "landing-module--rightBar--UL0C2";
export var rightBar1 = "landing-module--rightBar1--dVJ5G";
export var rightBar3 = "landing-module--rightBar3--6bZE5";
export var rightIcon = "landing-module--rightIcon--9fi7O";
export var skillsContainer = "landing-module--skillsContainer--E82UA";